export default {"src":"/_next/static/media/bananas.4925eeb3.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};